import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MIDPOINT',
  version: 1,
  label: 'Midpoint',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 37,
  inputs: [period('timeperiod', 14)],
  outputs: [line('midpoint', 'Midpoint', COLOR.blue)],
  talib: { functions: ['MIDPOINT'], expr: 'MIDPOINT(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
